import { Link } from "react-router-dom"
import { Chip } from "@mui/material"
import RoleBasedNavigator from "../components/RoleBasedNavigator"
import { formatTimeLeft } from "./negotiation-utils"
import { toUSD } from "./grid-value-formatters"

export function renderLink ({ value }) {
    return <a href={value} target="_blank">{value}</a>
}

export function renderNavigator (params) {
    return <Link to={`/negotiation/${params?.data?.case_id}/${params?.data?.id}`}>{params.value}</Link>
}

export function renderNavigatorWithState (params) {
    return <Link to={`${params?.data?.id}`} state={params?.data}>{params.value}</Link>
}

export function renderRoleBasedNavigator (params, roles) {
    return <RoleBasedNavigator params={params} allowedRoles={roles} />
}

export function renderDocViewLink (params) {
    return <Link to={`view/${params?.data?.id}`}>{params.value}</Link>
}

export function renderMailto ({ value }) {
    return <a href={`mailto:${value}`}>{value}</a>
}

// Negotiation status reflecting expiry: Settled (green) / Expired (red) / Awaiting response / Open + time left
export function renderNegotiationStatus ({ data }) {
    if (!data) return null
    const blind = data.mode === "BLIND"
    const live = data.status === "INITIAL" || data.status === "OPEN"
    let label = data.status === "INITIAL" ? "Awaiting response" : "Open"
    let cls = "!bg-[#e8f1fb] !text-[#1d4f91]"
    let hint = null
    if (data.status === "CLOSED") {
        label = "Settled"
        cls = "!bg-[#e6f4ea] !text-[#1e7e34]"
    } else if (data.status === "WITHDRAWN") {
        label = "Withdrawn"
        cls = "!bg-[#eceff1] !text-[#546e7a]"
    } else if (data.status === "ENDED") {
        label = "Ended"
        cls = "!bg-[#fff4e0] !text-[#b26a00]"
        hint = "No match"
    } else if (data.expired) {
        label = "Expired"
        cls = "!bg-[#fdecea] !text-[#c62828]"
    } else if (typeof data.seconds_left === "number") {
        hint = `${formatTimeLeft(data.seconds_left)} left`
        if (blind) hint = `Due ${formatTimeLeft(data.seconds_left)}`
    }
    if (live && !hint && blind && data.blind_round) {
        hint = data.max_rounds ? `Round ${data.blind_round} of ${data.max_rounds}` : `Round ${data.blind_round}`
    }
    return (
        <span className="flex h-full items-center gap-2 whitespace-nowrap">
            <Chip size="small" label={label} className={`${cls} !font-semibold`} />
            {blind ? <Chip size="small" variant="outlined" label="Confidential" className="!border-[#6a4fb3] !text-[#6a4fb3]" /> : null}
            {hint ? <span className="text-xs text-[#666]" title={blind && typeof data.seconds_left === "number" ? "Round deadline" : undefined}>{hint}</span> : null}
        </span>
    )
}

// Blind negotiations have no opening / latest figure to show
export function negotiationAmount ({ value, data }) {
    if (data?.mode === "BLIND") return "—"
    if (data?.monetary === false) return "Terms only"
    return toUSD({ value })
}
